<template>

	<a class="c-property-card" :href="property.url">
		<div class="c-property-card__image-wrapper">
			<picture v-if="property.imageUri">
				<source :srcset="property.imageUri + '?format=webp'" type="image/webp" />
				<img class="c-property-card__image" :src="property.imageUri" loading="lazy" />
			</picture>
		</div>
		<div class="c-property-card__name">{{property.headerText}}</div>
		<div class="c-property-card__flag" v-if="property.flag">
			{{property.flag}}
		</div>
		<div class="c-property-card__address">{{property.address}}</div>
		<div class="c-property-card__split">
			<div class="c-property-card__price">${{property.price}} per week</div>
			<div class="c-property-card__id">Property ID: {{property.listingReference}}</div>
		</div>
		<div class="c-property-card__attributes-wrapper">
			<div class="c-property-card__attribute">
				<div class="c-property-card__attribute-icon">
					<img src="/Content/images/interface/icons/bedrooms.svg" loading="lazy" />
				</div>
				<div class="c-property-card__attribute-value">{{property.bedrooms}}</div>
			</div>
			<div class="c-property-card__attribute">
				<div class="c-property-card__attribute-icon">
					<img src="/Content/images/interface/icons/bathrooms.svg" loading="lazy" />
				</div>
				<div class="c-property-card__attribute-value">{{property.bathrooms}}</div>
			</div>
			<div class="c-property-card__attribute">
				<div class="c-property-card__attribute-icon">
					<img src="/Content/images/interface/icons/parking.svg" loading="lazy" />
				</div>
				<div class="c-property-card__attribute-value">{{property.offStreetCarparks}}</div>
			</div>
		</div>
	</a>

</template>

<script>
	export default {
		name: 'property-tile',
		props: ['property'],
		data() {
			return {

			}
		},
		mounted() {

		},
		methods: {

		}
	};
</script>